module.exports = __webpack_public_path__ + "static/media/iconoFirma1.87296d18.svg";